<template>
    <div v-if="visible">
        <el-dialog title="设置学校组织" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="800px">    
            <el-table
                :data="depts"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                row-key="id"
                border
                lazy
                height="450"
                :load="load">
                <!-- <el-table-column type="index" :index="indexMethod" label="序号" width="50px"></el-table-column> -->
                <el-table-column prop="text" label="组织名称"></el-table-column>
                <el-table-column prop="attributes.nature" label="类型" width="100px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.attributes.nature == 1">
                            幼儿园
                        </div>
                        <div v-else-if="scope.row.attributes.nature == 2">
                            小学
                        </div>
                        <div v-else-if="scope.row.attributes.nature == 3">
                            中学
                        </div>
                        <div v-else-if="scope.row.attributes.nature == 0">
                            其他
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="attributes.deptControllerName" label="学校负责人" width="100px"></el-table-column>
                <el-table-column fixed="right" label="操作" width="110px">
                    <template slot-scope="scope">
                         <el-button @click.native.prevent="setAdd(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">新增</span>
                        </el-button>
                        <el-button  v-if="scope.row.parentId != 0" @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button  v-if="scope.row.parentId != 0" style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import add from './Add.vue'; 
    import update from './SetSchoolDeptUpdate.vue'; 

    export default {
        components:{
            add,update
        },
        data(){
            return{
                loading:false,
                visible: false,
                addVisible:false,
                updateVisible:false,
                querForm:{
                    id:"", //组织ID
                    schoolId: "", // 学校ID
                },
                depts:[]
            }
        },
        methods:{
            init(data){
                this.visible = true
                this.querForm.schoolId = data.id
                this.getData()
            },
            getData(){
                this.loading=true
                let url  = this.deptSetSchoolDeptUrl
                let data = {
                    schoolId: this.querForm.schoolId
                }
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data.depts));
                    if(res.status == 200){
                       this.depts = res.data.depts
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            // 新增界面
            setAdd(data){
                this.addVisible = true;
                this.$nextTick(() => {
                    this.$refs['add'].init(data);
                })
            },
            // 修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            // 删除
            del(data){
                this.querForm.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.deptDelUrl;
                let data = {
                    id:this.querForm.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip("删除成功",1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            dialogClose(done){
                done()
                this.$parent.getData()
            },
            load(tree, treeNode, resolve) {
                console.log('加载数据...')
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/sys/dept/SetSchoolDept.vue